module.exports = __webpack_public_path__ + "static/media/icon-happy.c76732d5.svg";